import { useEffect, useState } from "react";
import { fetchPartners } from "../api/opsApi";
import { PARTNERS_DEFAULT } from "../data/partnersDefault";

// The partner logos along the foot of the home page.
//
// Nothing saved yet, or an API that cannot be reached, falls back to the list the page ships
// with - the band is decoration, and an empty strip would read as a broken page.
export default function usePartners() {
  const [partners, setPartners] = useState(PARTNERS_DEFAULT);

  useEffect(() => {
    const controller = new AbortController();
    fetchPartners({ signal: controller.signal })
      .then((saved) => {
        if (Array.isArray(saved) && saved.length) setPartners(saved);
      })
      .catch(() => {
        /* the shipped list stands */
      });
    return () => controller.abort();
  }, []);

  return partners;
}
